const _temp0 = require("url:../assets/images/slideshows/alchematch-01.png");

const _temp1 = require("url:../assets/images/slideshows/alchematch-02.png");

const _temp2 = require("url:../assets/images/slideshows/alchematch-03.png");

const _temp3 = require("url:../assets/images/slideshows/alchematch-04.png");

const _temp4 = require("url:../assets/images/slideshows/alchematch-05.png");

const _temp5 = require("url:../assets/images/slideshows/fvtt-tongues-01.png");

const _temp6 = require("url:../assets/images/slideshows/fvtt-tongues-02.png");

const _temp7 = require("url:../assets/images/slideshows/fvtt-tongues-03.png");

const _temp8 = require("url:../assets/images/slideshows/gospel-of-ruin-01.jpg");

const _temp9 = require("url:../assets/images/slideshows/gospel-of-ruin-02.jpg");

const _temp10 = require("url:../assets/images/slideshows/gospel-of-ruin-03.jpg");

const _temp11 = require("url:../assets/images/slideshows/gospel-of-ruin-04.jpg");

const _temp12 = require("url:../assets/images/slideshows/gospel-of-ruin-05.jpg");

const _temp13 = require("url:../assets/images/slideshows/last-bastion-01.png");

const _temp14 = require("url:../assets/images/slideshows/last-bastion-02.png");

const _temp15 = require("url:../assets/images/slideshows/last-bastion-03.png");

const _temp16 = require("url:../assets/images/slideshows/lightbound-01.png");

const _temp17 = require("url:../assets/images/slideshows/lightbound-02.png");

const _temp18 = require("url:../assets/images/slideshows/lightbound-03.png");

const _temp19 = require("url:../assets/images/slideshows/pf-wotr-srk-homebrew-01.png");

const _temp20 = require("url:../assets/images/slideshows/pf-wotr-srk-homebrew-02.png");

const _temp21 = require("url:../assets/images/slideshows/pf-wotr-srk-homebrew-03.png");

const _temp22 = require("url:../assets/images/slideshows/pf-wotr-srk-homebrew-04.png");

const _temp23 = require("url:../assets/images/slideshows/pf-wotr-srk-homebrew-05.png");

const _temp24 = require("url:../assets/images/slideshows/pf-wotr-srk-homebrew-06.png");

const _temp25 = require("url:../assets/images/slideshows/pf-wotr-srk-homebrew-07.png");

const _temp26 = require("url:../assets/images/slideshows/pf-wotr-srk-homebrew-08.png");

const _temp27 = require("url:../assets/images/slideshows/the-last-gork-01.png");

const _temp28 = require("url:../assets/images/slideshows/the-last-gork-02.png");

const _temp29 = require("url:../assets/images/slideshows/the-last-gork-03.png");

const _temp30 = require("url:../assets/images/slideshows/the-last-gork-04.png");

const _temp31 = require("url:../assets/images/slideshows/the-last-gork-05.png");

module.exports = {
  "alchematch-01":   {
    "png": _temp0
  },
  "alchematch-02":   {
    "png": _temp1
  },
  "alchematch-03":   {
    "png": _temp2
  },
  "alchematch-04":   {
    "png": _temp3
  },
  "alchematch-05":   {
    "png": _temp4
  },
  "fvtt-tongues-01":   {
    "png": _temp5
  },
  "fvtt-tongues-02":   {
    "png": _temp6
  },
  "fvtt-tongues-03":   {
    "png": _temp7
  },
  "gospel-of-ruin-01":   {
    "jpg": _temp8
  },
  "gospel-of-ruin-02":   {
    "jpg": _temp9
  },
  "gospel-of-ruin-03":   {
    "jpg": _temp10
  },
  "gospel-of-ruin-04":   {
    "jpg": _temp11
  },
  "gospel-of-ruin-05":   {
    "jpg": _temp12
  },
  "last-bastion-01":   {
    "png": _temp13
  },
  "last-bastion-02":   {
    "png": _temp14
  },
  "last-bastion-03":   {
    "png": _temp15
  },
  "lightbound-01":   {
    "png": _temp16
  },
  "lightbound-02":   {
    "png": _temp17
  },
  "lightbound-03":   {
    "png": _temp18
  },
  "pf-wotr-srk-homebrew-01":   {
    "png": _temp19
  },
  "pf-wotr-srk-homebrew-02":   {
    "png": _temp20
  },
  "pf-wotr-srk-homebrew-03":   {
    "png": _temp21
  },
  "pf-wotr-srk-homebrew-04":   {
    "png": _temp22
  },
  "pf-wotr-srk-homebrew-05":   {
    "png": _temp23
  },
  "pf-wotr-srk-homebrew-06":   {
    "png": _temp24
  },
  "pf-wotr-srk-homebrew-07":   {
    "png": _temp25
  },
  "pf-wotr-srk-homebrew-08":   {
    "png": _temp26
  },
  "the-last-gork-01":   {
    "png": _temp27
  },
  "the-last-gork-02":   {
    "png": _temp28
  },
  "the-last-gork-03":   {
    "png": _temp29
  },
  "the-last-gork-04":   {
    "png": _temp30
  },
  "the-last-gork-05":   {
    "png": _temp31
  }
}